import { IFetchConfig } from "@elsa-zku/lib/helpers/fetch";
import fetch from "./http-client";

import { EntranceFormType, EntrancePass } from "./data-contracts";

export const getAppEntrancepassGetentries = (
  query?: {
    /** filter parameters */
    filter?: object;
    /** page */
    page?: number;
    /** limit */
    limit?: number;
    /** sort field */
    sortby?: string;
    /** sort direction */
    sortdir?: "desc" | "asc";
  },
  params?: IFetchConfig,
) =>
  fetch<{
    data: EntrancePass[];
    total: number;
    limit: number;
    page: number;
  }>("GET", `entrance`, query, params);

export const postAppEntrancepassAddentrancepass = (data: EntranceFormType, params?: IFetchConfig) =>
  fetch<EntrancePass>("POST", `entrance`, data, params);

export const getAppEntrancepassGetbyid = (id: number, params?: IFetchConfig) =>
  fetch<EntrancePass>("GET", `entrance/${id}`, null, params);

export const putAppEntrancepassEditentrancepass = (id: number, data: EntranceFormType, params?: IFetchConfig) =>
  fetch<EntrancePass>("PUT", `entrance/${id}`, data, params);

export const deleteAppEntrancepassDeleteentrancepass = (id: number, params?: IFetchConfig) =>
  fetch<void>("DELETE", `entrance/${id}`, null, params);

export const putAppEntrancepassSetentrancepassvisited = (id: number, params?: IFetchConfig) =>
  fetch<void>("PUT", `entrance/${id}/visit`, null, params);

export const putAppEntrancepassSetentrancepasscanceled = (id: number, params?: IFetchConfig) =>
  fetch<void>("PUT", `entrance/${id}/cancel`, null, params);
